const parseURL = (url: string): HTMLAnchorElement => {
  const parser: HTMLAnchorElement = document.createElement('a');
  parser.href = url;
  return parser;
};

const getLocation = (type: string): Location | HTMLAnchorElement => {
  if (type === 'node') {
    if (import.meta.env !== undefined) {
      // running in Vite Environment
      if (import.meta.env.VITE_BACKEND_API_URL) {
        return parseURL(import.meta.env.VITE_BACKEND_API_URL);
      }
      return window.location;
    }

  } else if (type === 'django') {
    return parseURL(import.meta.env.VITE_DJANGO_BACKEND_API_URL);
  }
  return window.location;
};

export const getFullURL = (relPath: string, type: string = 'node', params?: URLSearchParams): string => {
  const loc: HTMLAnchorElement | Location = getLocation(type);
  const url: URL = new URL(relPath, `${loc.protocol}//${loc.host}`)
  
  if (params) {
    url.search = params.toString();
  }
  
  return url.toString();
}
